"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_ACTION_PROTOTYPE_MAPPING = exports.TagEventPrototypes = exports.TagEventRelevances = exports.StandardActions = exports.TagEventBase = void 0;
class TagEventBase {
}
exports.TagEventBase = TagEventBase;
exports.StandardActions = [
    "sees",
    "meets",
    "enters",
    "exits",
    "entersScene",
    "exitsScene",
    "other",
    "transaction",
    "departsFrom",
    "arrivesAt",
    "passes",
    "comments",
];
exports.TagEventRelevances = ["unset", "unknown", "uninteresting", "interesting", "critical"];
exports.TagEventPrototypes = ["subject", "subject-object", "subject-location", "passive"];
exports.STANDARD_ACTION_PROTOTYPE_MAPPING = {
    sees: "subject-object",
    meets: "subject-object",
    enters: "subject-object",
    exits: "subject-object",
    entersScene: "subject",
    exitsScene: "subject",
    other: "subject",
    transaction: "subject",
    departsFrom: "subject-location",
    arrivesAt: "subject-location",
    passes: "subject-location",
    comments: "passive",
};
